export default [
  {
    component: 'CNavItem',
    name: 'My Fundraisers',
    to: '/account',
    badge: {
      color: 'success',
      text: '*',
    },
  },
  {
    component: 'CNavTitle',
    name: 'My Account',
  },
  {
    component: 'CNavItem',
    name: 'Summary',
    to: '/summary',
    icon: 'cil-speedometer',
    badge: {
      color: 'primary',
    },
  },
  {
    component: 'CNavItem',
    name: 'My Statement',
    to: '/donations',
    icon: 'cil-wallet',
    badge: {
      color: 'primary',
    },
  },
  {
    component: 'CNavItem',
    name: 'Withdraw',
    to: '/withdraw',
    icon: 'cil-arrow-thick-to-top',
    badge: {
      color: 'primary',
    },
  },
  {
    component: 'CNavTitle',
    name: 'Verifications',
  },
  {
    component: 'CNavItem',
    name: 'Documents',
    to: '/documents',
    icon: 'cil-paperclip',
    badge: {
      color: 'primary',
    },
  },
  {
    component: 'CNavItem',
    name: 'Treasurers',
    to: '/treasurers',
    icon: 'cil-shield-alt',
    badge: {
      color: 'primary',
    },
  },
  {
    component: 'CNavTitle',
    name: 'Personalization',
  },
  {
    component: 'CNavItem',
    name: 'Fundraiser Details',
    to: '/fundraiser-details',
    icon: 'cil-pencil',
  },
  {
    component: 'CNavItem',
    name: 'Story',
    to: '/story',
    icon: 'cil-paragraph',
  },
  {
    component: 'CNavItem',
    name: 'Images',
    to: '/images',
    icon: 'cil-image-plus',
  },
  {
    component: 'CNavItem',
    name: 'Video',
    to: '/video',
    icon: 'cil-video',
  },
  /*{
    component: 'CNavItem',
    name: 'Patrons',
    to: '/patrons',
    icon: 'cil-contact',
  },*/
  {
    component: 'CNavTitle',
    name: 'Utilities',
  },
  {
    component: 'CNavItem',
    name: 'Feedback',
    to: '/feedback',
    icon: 'cil-chat-bubble',
  },
  {
    component: 'CNavItem',
    name: 'Share',
    to: '/share',
    icon: 'cil-share-alt',
  },
  {
    component: 'CNavItem',
    name: 'Update Donors',
    to: '/update-donors',
    icon: 'cil-people',
    class: 'ke-only',
  },
  {
    component: 'CNavItem',
    name: 'M-Changa Affiliates',
    to: '/mchanga-affiliates',
    icon: 'cil-dollar',
    class: 'ke-only',
  },
  {
    component: 'CNavTitle',
    name: 'Account',
  },
  {
    component: 'CNavItem',
    name: 'Logout',
    to: '/logout',
    icon: 'cil-power-standby',
  },
  /*{
    component: 'CNavItem',
    name: 'Referral',
    to: '/referral',
    icon: 'cil-lightbulb',
  },*/
]
